import { create } from 'zustand'

interface SearchState {
  searchQuery: string
  isSearchActive: boolean
}

interface SearchStore extends SearchState {
  setSearchQuery: (query: string) => void
  clearSearch: () => void
  reset: () => void
}

export const useSearchStore = create<SearchStore>((set, get) => ({
  searchQuery: '',
  isSearchActive: false,
  setSearchQuery: (query: string) =>
    set({
      searchQuery: query,
      isSearchActive: query.trim().length > 0,
    }),
  clearSearch: () =>
    set({
      searchQuery: '',
      isSearchActive: false,
    }),
  reset: () => get().clearSearch(),
}))
